import React from 'react'

import { GetStaticProps } from 'next'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { dehydrate, QueryClient } from '@tanstack/react-query'
import { NextPageWithLayout } from '@mindfulchefuk/types/NextJS'
import { DeprecatedChooseRecipesLayout } from '@mindfulchefuk/features/Onboarding/components/layout/DeprecatedChooseRecipesLayout'
import { getCMSPage } from '@mindfulchefuk/features/CMS/services/getCMSPage'
import { getCMSGlobalContent } from '@mindfulchefuk/features/CMS/services/getCMSGlobalContent'
import { flagChooseRecipesOnboardingRefactor } from '@mindfulchefuk/flagsAndExperiments'
import { ChooseRecipesProvider } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingChooseRecipesPage } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesPage'
import { DeprecatedChooseRecipesPage } from '@mindfulchefuk/onboarding/components/DeprecatedChooseRecipesPage/DeprecatedChooseRecipesPage'

export const ChooseRecipes: NextPageWithLayout = () => {
  const isChooseRecipesRefactorEnabled = useFeatureIsOn(
    flagChooseRecipesOnboardingRefactor
  )

  if (isChooseRecipesRefactorEnabled) {
    return (
      <ChooseRecipesProvider>
        <OnboardingChooseRecipesPage />
      </ChooseRecipesProvider>
    )
  }

  return (
    <DeprecatedChooseRecipesLayout
      canonical="choose-recipes"
      title="Choose recipes"
    >
      <DeprecatedChooseRecipesPage />
    </DeprecatedChooseRecipesLayout>
  )
}

export default ChooseRecipes

export const getStaticProps: GetStaticProps = async () => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(['cms-page-recipe-onboarding'], () =>
    getCMSPage('page-recipe-onboarding')
  )
  await queryClient.prefetchQuery(['cms-global-content'], getCMSGlobalContent)

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: parseInt(process.env.NEXT_PUBLIC_CMS_REVALIDATE_INTERVAL, 10),
  }
}
